export enum PageListItemDropdownAction {
  SetAsHomepage = 'setAsHomepage',
  Edit = 'edit',
  Delete = 'delete',
  Duplicate = 'duplicate'
}
